import { HStack, VStack, IconButton, Text, FormRow } from '@cad-arc';
import { EventSearchOptions } from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { FormInput } from '../forms/integrated-form-controls/form-input';
import { FormSelect } from '../forms/integrated-form-controls/form-select';
import { FormTextarea } from '../forms/integrated-form-controls/form-text-area';
import { EventSearchFormType } from './types';

export function EventSearchFormPropertyFields({
    form,
    options,
    index,
    isRemovable,
    isFirstResponder,
    onRemove,
}: {
    form: UseFormReturn<EventSearchFormType>;
    options: EventSearchOptions;
    index: number;
    isRemovable: boolean;
    isFirstResponder?: boolean;
    onRemove: () => void;
}) {
    return (
        <VStack align="left">
            {isRemovable && (
                <HStack justifyContent="space-between">
                    <Text variant="headingXs">Property {index + 1}</Text>
                    <IconButton
                        variant="ghost"
                        icon="TrashCan"
                        aria-label="remove property"
                        size={isFirstResponder ? 'lg' : 'sm'}
                        onClick={() => onRemove()}
                    />
                </HStack>
            )}

            <FormRow>
                <FormSelect
                    name={`involvedItems.${index}.propertyType`}
                    label="Property Type"
                    control={form.control}
                    options={options.itemTypeOptions}
                    length="sm"
                />
                <FormSelect
                    name={`involvedItems.${index}.propertyCategory`}
                    label="Property Category"
                    control={form.control}
                    options={options.itemCategoryOptions}
                    length="sm"
                />
                <FormSelect
                    name={`involvedItems.${index}.color`}
                    label="Primary Color"
                    control={form.control}
                    options={options.itemColorOptions}
                    length="sm"
                />
            </FormRow>
            <FormRow>
                <FormInput
                    name={`involvedItems.${index}.serialNumber`}
                    label="Serial #"
                    control={form.control}
                    length="sm"
                    excludeFromFuzzySearch
                />
                <FormSelect
                    name={`involvedItems.${index}.firearmMake`}
                    label="Firearm Make"
                    control={form.control}
                    options={options.firearmMakeOptions}
                    length="sm"
                />
                <FormInput
                    name={`involvedItems.${index}.model`}
                    label="Firearm Model"
                    control={form.control}
                    length="sm"
                />
            </FormRow>
            <FormRow>
                <FormTextarea
                    name={`involvedItems.${index}.description`}
                    label="Description"
                    control={form.control}
                    length="md"
                />
            </FormRow>
        </VStack>
    );
}
